import { ReactElement } from "react";
import classNames from "classnames";
import { useUiContext } from "@rotorstudios/fe-ui";

import "./_UiaIconClose.scss";

type UiaIconCloseProps = {
  inverse?: boolean;
};

const UiaIconClose = ({ inverse = false }: UiaIconCloseProps): ReactElement => {
  const { projectClass } = useUiContext();

  const getClassName = () => classNames(`${projectClass}_UiaIconClose`, { inverse });

  return (
    <svg
      className={getClassName()}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 13.5L13.5 2.49999M13.5 13.5L7.99995 8.00011L2.5 2.49999"
        stroke="white"
        strokeWidth="0.8"
      />
    </svg>
  );
};

export default UiaIconClose;
